// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Bpbe","amount":"Amount_amount__1lZ30","tip":"Amount_tip__3PIlc","tipHeader":"Amount_tipHeader__2Nc8E","tipsWrap":"Amount_tipsWrap__2vc9F"};